import { IotSkeletonAvatar } from "@core/presentation/components/feedback/skeleton/iot-skeleton-avatar.component";
import { IotSkeletonInput } from "@core/presentation/components/feedback/skeleton/iot-skeleton-input.component";
import type { SkeletonProps } from "antd";
import { Skeleton } from "antd";
import type { FC } from "react";

export type IotSkeletonProps = SkeletonProps;

export const IotSkeleton: FC<IotSkeletonProps> & {
    Input: typeof IotSkeletonInput;
    Avatar: typeof IotSkeletonAvatar;
} = (props) => {
    const { children, active = true, ...restProps } = props;

    return (
        <Skeleton
            {...restProps}
            active={active}
        >
            {/* This overrides the default behaviour of Ant Design */}
            {/* they always render the children, we will not */}
            {restProps.loading ? null : children}
        </Skeleton>
    );
};

IotSkeleton.Input = IotSkeletonInput;
IotSkeleton.Avatar = IotSkeletonAvatar;
